// extracted by mini-css-extract-plugin
var _1 = "BuildingGroupTableLayout-modulepageActions__cAxX1 PageActions-modulePageActions__lL8Sl";
export { _1 as "pageActions" }
